<div class="add-container">
    <h1 class="add-title">Actualizare template document</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <!-- Document Configuration Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="fas fa-cog me-2"></i>
                    Configurări Document
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <p>Adresă</p>
                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                            (change)="onAdresaChange($event)" formControlName="is_address">
                            <mat-button-toggle [value]="true">Da</mat-button-toggle>
                            <mat-button-toggle [value]="false">Nu</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <div class="col-md-4">
                        <p>Registru Oficial</p>
                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                            (change)="onRegistruChange($event)" formControlName="registru_necessary">
                            <mat-button-toggle [value]="true">Da</mat-button-toggle>
                            <mat-button-toggle [value]="false">Nu</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <div class="col-md-4">
                        <p>Exemplare diferite?</p>
                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                            (change)="onDualChange($event)" formControlName="document_generabil_dual">
                            <mat-button-toggle [value]="true">Da</mat-button-toggle>
                            <mat-button-toggle [value]="false">Nu</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>
            </div>
        </div>

        <!-- Basic Information Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="fas fa-info-circle me-2"></i>
                    Informații de Bază
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Tip Cerere/Document</mat-label>
                            <mat-select formControlName="type_id" (openedChange)="onTipCerereSelectClosed()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="tipCerereControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredTipCerere.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let tipCerere of filteredTipCerere" [value]="tipCerere.id">
                                    {{ tipCerere.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Denumire</mat-label>
                            <input type="text" matInput formControlName="name" />
                            <mat-error *ngIf="
			              !form.controls['name'].valid && form.controls['name'].touched
			            ">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- Organization and Category Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="fas fa-tags me-2"></i>
                    Organizare și Categorizare
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Direcție</mat-label>
                            <mat-select formControlName="directie_id" (openedChange)="onDirectieSelectClosed()"
                                (selectionChange)="onDirectieChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="!form.controls['directie_id'].valid && form.controls['directie_id'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Compartiment</mat-label>
                            <mat-select formControlName="compartiment_id" (openedChange)="onCompartimentSelectClosed()"
                                (selectionChange)="onCompartimentChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="compartimenteControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let compartiment of filteredCompartimente"
                                    [value]="compartiment.id">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Categoria Primară (opțional)</mat-label>
                            <mat-select (openedChange)="onParentCategoriesSelectClosed()"
                                formControlName="primary_category_id">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="parentCategoriesControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredParentCategories.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let category of filteredParentCategories" [value]="category.id">
                                    {{ category.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <!-- Registry Section -->
        <div class="card mb-3">
            <div class="card-header">
                <h4 class="card-title mb-0">
                    <i class="fas fa-book me-2"></i>
                    Registru
                </h4>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <mat-form-field class="w-100" appearance="fill">
                            <mat-label>Registru</mat-label>
                            <mat-select formControlName="registru_id">
                                <mat-option *ngFor="let row of registre$ | async" [value]="row.id">
                                    {{ row.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDestinatieChange($event)"
                formControlName="destination">
                <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
                <mat-button-toggle *ngIf="form.get('document_generabil_dual')?.value == true"
                    value="toCetatean">Exemplar
                    Cetățean</mat-button-toggle>
                <mat-button-toggle *ngIf="form.get('document_generabil_dual')?.value == true"
                    value="toate">Toate</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <br />
        <div class="row">
            <div class="col" *ngIf="destination == 'toPrimarie' || destination == 'toate'">
                <br />
                <div class="col">
                    <div class="d-flex gap-2 align-items-center mb-3">
                        <h2 class="fw-bold m-0">Exemplar Semnatari</h2>
                        <button type="button" class="btn btn-sm btn-danger ms-1" (click)="printTemplate(1)">
                            Printare
                        </button>
                    </div>
                    <br />
                    <angular-editor class="fit-screen" formControlName="context"
                        [config]="editorConfig"></angular-editor>
                </div>
            </div>
            <div class="col" *ngIf="destination == 'toCetatean' || destination == 'toate'">
                <br />
                <div class="col">
                    <div class="d-flex gap-2 align-items-center mb-3">
                        <h2 class="fw-bold m-0">Exemplar Cetățean</h2>
                        <button type="button" class="btn btn-sm btn-danger ms-1" (click)="printTemplate(2)">
                            Printare
                        </button>
                    </div>
                    <br />
                    <angular-editor class="fit-screen" formControlName="context_cetatean"
                        [config]="editorConfig"></angular-editor>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>